module.exports = __webpack_public_path__ + "img/caret_down.026c7df8.svg";